// src/pages/Cookies.js
import React from 'react';
import '../styles/Cookies.css';

const Cookies = () => {
    return (
        <div className="cookies-page">
            <h1>Politique Relative aux Cookies</h1>

            <h2>1. Introduction</h2>
            <p>
                Le site Naninan, plateforme dédiée à la promotion des événements cinématographiques, à l’information sur les sorties de films et à la collecte d’avis des utilisateurs, est édité par Africa Data Entry.
            </p>
            <p>
                La présente Politique relative aux Cookies a pour objet d’informer les visiteurs du Site sur la nature des cookies utilisés, leur finalité et les moyens mis à leur disposition pour gérer ces cookies.
            </p>
            <p>
                En naviguant sur Naninan, l’Utilisateur accepte l’utilisation des cookies conformément à la présente politique.
            </p>

            <h2>2. Qu’est-ce qu’un Cookie ?</h2>
            <p>
                Un cookie est un petit fichier texte déposé sur le terminal (ordinateur, smartphone, tablette) de l’Utilisateur lors de sa visite sur un site internet.
            </p>
            <p>
                Les cookies permettent de recueillir des informations relatives à la navigation (par exemple, pages visitées, temps de visite, préférences) et d’améliorer l’expérience de l’Utilisateur sur le Site.
            </p>

            <h2>3. Types de Cookies Utilisés</h2>
            <h3>3.1. Cookies Techniques</h3>
            <p>
                Ces cookies sont indispensables au bon fonctionnement du Site. Ils permettent par exemple :
            </p>
            <ul>
                <li>La gestion de la session de l’Utilisateur.</li>
                <li>La navigation entre les pages.</li>
                <li>L’accès aux zones sécurisées du Site.</li>
            </ul>

            <h3>3.2. Cookies Analytiques</h3>
            <p>
                Ces cookies permettent de collecter des informations sur la manière dont les visiteurs utilisent le Site (nombre de visites, pages consultées, durée de la visite, etc.).
            </p>
            <p>
                Ces données sont utilisées pour améliorer le contenu et les fonctionnalités du Site et ne permettent pas d’identifier personnellement les visiteurs.
            </p>

            <h3>3.3. Cookies Fonctionnels</h3>
            <p>
                Ces cookies sont utilisés pour mémoriser les préférences de l’Utilisateur (langue, affichage, paramètres personnalisés) afin de lui offrir une navigation optimisée et personnalisée.
            </p>

            <h3>3.4. Cookies Publicitaires (si applicable)</h3>
            <p>
                Dans certains cas, des cookies publicitaires peuvent être déployés afin de proposer des contenus et des offres adaptées aux centres d’intérêt de l’Utilisateur.
            </p>
            <p>
                Ces cookies peuvent être déposés par des partenaires tiers et permettent de suivre l’efficacité des campagnes publicitaires.
            </p>

            <h2>4. Finalités de l’Utilisation des Cookies</h2>
            <p>
                Les cookies sur le Site Naninan ont pour principales finalités :
            </p>
            <ul>
                <li>Assurer le fonctionnement et la sécurité du Site : Ils garantissent une navigation fluide et sécurisée.</li>
                <li>Analyser l’audience et l’usage du Site : Ces données permettent d’améliorer la qualité du contenu et l’ergonomie du Site.</li>
                <li>Personnaliser l’expérience utilisateur : En mémorisant les préférences de l’Utilisateur, ils facilitent l’accès aux informations pertinentes sur les films et événements.</li>
                <li>Proposer des contenus adaptés (lorsque applicable) : Certains cookies publicitaires permettent d’afficher des annonces en adéquation avec les centres d’intérêt des visiteurs.</li>
            </ul>

            <h2>5. Gestion des Cookies</h2>
            <h3>5.1. Acceptation des Cookies</h3>
            <p>
                Lors de la première visite sur Naninan, un bandeau d’information s’affiche afin de demander l’acceptation des cookies. En poursuivant la navigation, l’Utilisateur consent à leur utilisation conformément à cette Politique.
            </p>
            <h3>5.2. Désactivation et Suppression des Cookies</h3>
            <p>
                L’Utilisateur peut à tout moment configurer son navigateur pour refuser l’installation des cookies ou supprimer ceux déjà déposés.
            </p>
            <p>Voici quelques exemples de procédures selon les navigateurs les plus courants :</p>
            <ul>
                <li>Google Chrome : Paramètres &gt; Confidentialité et sécurité &gt; Cookies et autres données de site.</li>
                <li>Mozilla Firefox : Options &gt; Vie privée et sécurité &gt; Cookies et données de sites.</li>
                <li>Safari : Préférences &gt; Confidentialité &gt; Bloquer tous les cookies.</li>
                <li>Internet Explorer/Edge : Options Internet &gt; Confidentialité &gt; Avancé.</li>
            </ul>
            <p>
                Il est à noter que la désactivation des cookies pourrait limiter l’accès à certaines fonctionnalités du Site.
            </p>

            <h2>6. Cookies de Tiers</h2>
            <p>
                Le Site peut intégrer des services tiers (par exemple, outils d’analyse ou réseaux sociaux) qui déposent leurs propres cookies.
            </p>
            <p>
                Ces cookies relèvent des politiques de confidentialité de ces tiers et ne sont pas contrôlés par Africa Data Entry. Nous vous recommandons de consulter les politiques relatives aux cookies de ces partenaires pour plus d’informations.
            </p>

            <h2>7. Durée de Conservation</h2>
            <p>
                La durée de conservation des cookies varie en fonction de leur finalité.
            </p>
            <p>
                Les cookies techniques sont généralement supprimés à la fin de la session de navigation.
            </p>
            <p>
                Les cookies analytiques ou fonctionnels peuvent être conservés pour une durée plus longue afin d’analyser les tendances de navigation et mémoriser les préférences de l’Utilisateur.
            </p>

            <h2>8. Modifications de la Politique Relative aux Cookies</h2>
            <p>
                Africa Data Entry se réserve le droit de modifier la présente Politique à tout moment afin de l’adapter aux évolutions du Site ou de la réglementation en vigueur.
            </p>
            <p>
                Il est conseillé de consulter régulièrement cette page afin de prendre connaissance des éventuelles modifications.
            </p>

            <h2>9. Contact</h2>
            <p>
                Pour toute question ou demande d’information relative à la présente Politique, l’Utilisateur peut contacter Africa Data Entry par :
            </p>
            <ul>
                <li>Adresse e-mail : <a href="mailto:contact@africadataentry.com">contact@africadataentry.com</a></li>
                <li>Téléphone : <a href="tel:+22604443988">+226 04 44 39 88</a></li>
                <li>Adresse Postale : 17 BV 30065 OUAGA PISSY 10050 OUAGADOUGOU BURKINA FASO</li>
            </ul>
        </div>
    );
};

export default Cookies;
